export const getRequiredFields = (
  recordType: string,
  isPersonValue?: string
): string[] => {
  switch (recordType) {
    case "Lead":
    case "Prospect":
    case "Customer":
      if (
        isPersonValue === "2" ||
        isPersonValue?.toLowerCase() === "company" ||
        isPersonValue?.toLowerCase() === "f"
      ) {
        return ["isperson", "subsidiary", "companyname", "email"];
      }

      return ["isperson", "subsidiary", "firstname", "lastname", "email"];

    case "Opportunity":
      return ["entity", "custbody_end_user", "custbody_order_type"];

    case "Order":
      return [
        "entity",
        "item:item",
        "custbody_end_user",
        "custbody_order_type",
        "startdate"
      ];

    case "SupportCase":
      return ["title", "company"];

    case "Account":
      return ["acctname", "acctnumber", "currency"];

    case "ReturnAuthorization":
      return [
        "entity:id",
        "custbody_end_user:id",
        "custbody_order_type:id",
        "item:items:item:id",
        "item:items:amount"
      ];

    case "Estimate":
      return [
        "entity",
        "custbody_end_user",
        "custbody_order_type",
        "item:items:item:id"
      ];

    case "InventoryItem":
      return [
        "itemid",
        "displayname",
        "custitem_product_line",
        "custitem_quantity_type",
        "custitem_item_category",
        "taxschedule",
        "assetaccount",
        "incomeaccount",
        "cogsaccount"
      ];

    default:
      return [];
  }
};
